import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'leaflet/dist/leaflet.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import 'html2canvas';
import App from './App';

// Force rebuild v3 - BuyCardsModal integration

// Capturar parámetro ?tito=TOKEN en la primera carga y guardarlo en localStorage
try {
  if (typeof window !== 'undefined' && window.location && window.location.search) {
    const params = new URLSearchParams(window.location.search);
    const titoParam = params.get('tito');
    if (titoParam) {
      localStorage.setItem('tito_token', titoParam.trim());
    }
  }
} catch (e) {
  console.warn('No se pudo procesar el token de Tito desde la URL inicial:', e);
}

// Initialize Telegram WebApp
if (window.Telegram?.WebApp) {
  const tg = window.Telegram.WebApp;
  
  // Expand to full height
  tg.expand();
  
  // Enable closing confirmation
  tg.enableClosingConfirmation();
  
  // Set header color to match theme
  tg.setHeaderColor('#0B0E14');
  tg.setBackgroundColor('#0B0E14');
  
  // Ready
  tg.ready();
}

// Error boundary para capturar errores
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React Error Boundary caught:', error, errorInfo);
    
    // Auto-reload on chunk load errors (often caused by deploy cache mismatch)
    const errorStr = (error && (error.message || error.name || String(error))) || '';
    const isChunkError =
      errorStr.includes('ChunkLoadError') ||
      errorStr.includes('Loading chunk') ||
      errorStr.includes('Loading CSS chunk') ||
      errorStr.includes('Failed to fetch dynamically imported module') ||
      errorStr.includes('Unexpected token') ||
      errorStr.includes('Importing a module script failed') ||
      errorStr.includes('error loading dynamically imported module') ||
      errorStr.includes('Script error');

    if (isChunkError) {
      try {
        const lastReload = sessionStorage.getItem('last_chunk_reload');
        const now = Date.now();
        // Prevent infinite reload loops (e.g. offline or actual missing chunk)
        if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
          sessionStorage.setItem('last_chunk_reload', String(now));
          window.location.reload();
          return;
        }
      } catch (e) {
        console.warn('Failed to auto-reload on ChunkLoadError:', e);
      }
    }

    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleClearCacheAndReload = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
      if ('caches' in window) {
        caches.keys().then((names) => {
          for (const name of names) {
            caches.delete(name);
          }
        });
      }
    } catch (e) {
      console.warn('Failed to clear client caches:', e);
    }
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          color: 'white',
          backgroundColor: '#1a1a1a',
          minHeight: '100vh',
          fontFamily: 'monospace'
        }}>
          <h1 style={{ color: 'red' }}>❌ Error en la Aplicación</h1>
          <h2>Error:</h2>
          <pre style={{ color: 'orange', whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
          </pre>
          <h2>Stack:</h2>
          <pre style={{ color: 'yellow', whiteSpace: 'pre-wrap', fontSize: '12px' }}>
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </pre>
          <div style={{ marginTop: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button 
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 20px',
                backgroundColor: '#22d3ee',
                color: 'black',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Recargar Página
            </button>
            <button 
              onClick={this.handleClearCacheAndReload}
              style={{
                padding: '10px 20px',
                backgroundColor: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              🧹 Limpiar Caché y Reiniciar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

try {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
} catch (error) {
  console.error('Error al inicializar React:', error);
  document.getElementById('root').innerHTML = `
    <div style="padding: 20px; color: white; background: #1a1a1a; min-height: 100vh;">
      <h1 style="color: red;">❌ Error Crítico al Iniciar</h1>
      <pre style="color: yellow;">${error.toString()}</pre>
      <p>Revisa la Console del navegador (F12) para más detalles.</p>
    </div>
  `;
}
